import Wrapper from '../Render';
import {VueConstructor} from 'vue';
import { SerializeInterface, IntegrationStyles, IntegrationCommonStyles } from '../types';

abstract class PaymentGatewayIntegration {
    public abstract name: string;
    public abstract scriptUrl: string | null;
    public abstract integrationFields: any;
    public vm: Wrapper;

    public abstract fields: {
        cvc: VueConstructor,
        creditCard: VueConstructor,
        expiry: VueConstructor,
    };

    public isCvcOptional: boolean = true;

    public integrationStyles: IntegrationStyles[];
    public integrationCommonStyles: IntegrationCommonStyles[];
    public integrationData: any = {};
    public errorComponent: VueConstructor;
    public loadingComponent: VueConstructor;
    public autocomplete: boolean = false;

    constructor(vm: Wrapper, settings: any) {
        this.vm = vm;
        this.integrationStyles = settings.styles;
        this.integrationCommonStyles = settings.commonStyles;
        this.integrationData = settings.integrationData;
        this.errorComponent = settings.error;
        this.loadingComponent = settings.loading;
        if (settings.preSerialize) {
            this.preSerialize = settings.preSerialize;
        }
        if (settings.postSerialize) {
            this.postSerialize = settings.postSerialize;
        }
        if (settings.autocomplete) {
            this.autocomplete = true;
        }
    }

    public abstract created(): Promise<any>;

    public validate(hard?: boolean) {
        const creditCard = (this.vm.$refs.creditCard as any).validate(hard, true);
        const cvc = !this.vm.form.cvc.isEmpty
        || !this.isCvcOptional ? (this.vm.$refs.cvc as any).validate(hard, true) : true;
        const expiry = (this.vm.$refs.expiry as any).validate(hard, true);
        return {
            validation: {
                creditCard,
                expiry,
                cvc,
            },
            isValid: creditCard && expiry && cvc,
        };
    }

    public clearData() {
        (this.vm.$refs.creditCard as any).clearData();
        (this.vm.$refs.cvc as any).clearData();
        (this.vm.$refs.expiry as any).clearData();
    }

    public abstract async serialize(additionals: any): Promise<SerializeInterface>;

    protected preSerialize: any = (a, b) => b;
    protected postSerialize: any = (a, b) => b;
    protected async loadScript() {
        if (this.scriptUrl) {
            const id = `paymentGatewayIntegration_${this.name}`;
            const scriptDom = document.getElementById(id);
            if (!scriptDom) {
                const script = document.createElement('script');
                script.setAttribute('src', this.scriptUrl);
                script.setAttribute('id', `paymentGatewayIntegration_${this.name}`);
                script.setAttribute('loaded', 'no');

                return new Promise((resolve, reject) => {
                    script.onload = () => {
                        script.setAttribute('loaded', 'yes');
                        resolve('loaded');
                    };
                    setTimeout(() => {
                        reject();
                    }, 10000);
                    document.head.appendChild(script);
                }).catch((e: any) => this.vm.failed = true);
            } else {
                return new Promise((resolve, reject) => {
                    let counter = 0;
                    const doTimeout = () => {
                        setTimeout(() => {
                            counter++;
                            // @ts-ignore
                            if (scriptDom.attributes.loaded.nodeValue === 'yes') {
                                resolve('loaded');
                            } else if (counter <= 10000) {
                                doTimeout();
                            } else {
                                reject();
                            }
                        }, 1);
                    };

                    doTimeout();
                });
            }
        } else {
            this.vm.failed = true;
        }
    }
}

export {
    PaymentGatewayIntegration,
};
